import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /angebote. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * angebote.index.tsx, Detail-/Form-Routen (angebote.$id.tsx, angebote.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte angebote.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/angebote/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/angebote')({
  component: AngeboteLayout,
});

function AngeboteLayout() {
  return <Outlet />;
}
